var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasNote)?_c('p',{staticClass:"checkpoint-prep-note-block"},[_vm._v(_vm._s(_setup.plainText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }